import { useTheme, useMediaQuery } from '@mui/material';

const TABBREAKPOINT = "md"

export function useIsTab() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(TABBREAKPOINT));
}
